import { Styles, css, extractTransition, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    pointer-events: auto;
    z-index: 999;
  `,
  content: css`
    width: 420px;
    user-select: auto;
  `,
  contentHeader: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  `,
  contentHeaderTitle: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;

    color: ${theme.colors.neutral.variant[80]};
  `,
  contentHeaderSubtitle: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  candidateNameSharedPage: css`
    cursor: pointer;
    text-decoration: underline;
  `,
  contentBody: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-right: 8px;
    margin-right: -8px;

    overflow: auto;
    max-height: 300px;

    ${verticalScrollCss(theme)}
  `,
  contentBodyTextArea: css`
    min-height: 150px;
  `,
  pill: ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 26px;
    padding-left: 6px;
    padding-right: 9px;
    background-color: ${theme.colors.neutral.variant[10]};
    border-radius: 12px;
    cursor: default;

    ${extractTransition((f) => f.cubic, { property: 'background-color', duration: 220 })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[20]};
    }

    &,
    &:hover,
    &:active,
    &:visited {
      text-decoration: none;
    }
  `,
  disabledPill: ({ theme }) => css`
    &,
    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  contentFooter: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 8px;
  `,
  saveButtonContainer: css`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 12px;
  `,
  contentBodySelectGroupTitle: ({ theme }) => css`
    display: flex;
    align-items: center;
    padding: 3px 0 3px 16px;
    color: ${theme.colors.neutral.variant[60]};
  `,
  selectHelper: ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-top: 10px;
    gap: 4px;
    color: ${theme.colors.neutral.variant[50]};
    line-height: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
